import {Component, OnInit} from '@angular/core';
import {LpUiService} from './shared/lp-ui.service';
import {TerraUtils} from '../shared/TerraUtils';
import {RoutingService} from '../services/routing.service';
import {UserService} from '../services/shared/user.service';
import {map} from 'rxjs/operators';
import {UtilsService} from '../services/utils.service';

@Component({
  selector: 'terra-lp',
  templateUrl: './lp.component.html',
  styleUrls: ['./lp.component.scss']
})
export class LpComponent implements OnInit {

  isMainNavbarVisible$ = this.lpUiService.isMainNavbarVisible$;
  isMobileScreenSize = this.utilsService.isMobileScreenSize();

  logoutPath = TerraUtils.consts.paths.LOGOUT;

  userName$ = this.userService.accountDetails$.pipe(map(userDetails => {
    return `${userDetails.firstName} ${userDetails.lastName}`;
  }));

  constructor(private lpUiService: LpUiService, public routingService: RoutingService, private userService: UserService, private utilsService: UtilsService) { }

  ngOnInit() {
  }

}
